import { fnPostUrl } from "functions/Api";

export const postAuth = (data) => {
    const apiRequest = {
        endpoint: "/api/Auth/Register",
        body: data
    }

    return fnPostUrl(apiRequest);
}